import React from "react";
import classNames from "classnames";
import Button from "./Button";
import Icon from "../Icon/Icon";
import doneIcon from "icons/done.svg";


class ButtonBorder extends React.Component {
  render() {
    const { className, done, children, ...rest } = this.props;
    const buttonClasses = classNames(
      "button-border",
      className
    );

    return (
      <Button className={ buttonClasses } done={done} { ...rest }>
        {!done ? children : (
          <Icon glyph={doneIcon} className="button-border__done" />
        ) }
      </Button>
    );
  }
}

export default ButtonBorder;


// WEBPACK FOOTER //
// ./app/components/Button/ButtonBorder.jsx